export const modalBreakpoints = {
  '960px': '75vw',
  '640px': '90vw',
};
